module.exports = __webpack_public_path__ + "static/media/ils_goal.4d0f2ec5.svg";